module.exports = __webpack_public_path__ + "static/media/Map.5b1526d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Map.png
// module id = 127
// module chunks = 0